import r from "./atoms-v21002.js";
import { OverlayScrollbarsComponent as o } from "./atoms-v2133.js";
const a = r(o)`
  height: 100%;
  width: 100%;

  & .os-scrollbar-track {
    padding: 7px 0 !important;
  }
`;
export {
  a as Wrapper
};
